import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrderState } from '../states/order.state';
import { OrderItem } from '../../model/order-item';

export const selectOrderState = createFeatureSelector<OrderState>('order');

export const selectQuoteDetails = (id: string) =>
  createSelector(
    selectOrderState,
    state =>
      state.quotes.find(q => q.quotationDetails.idQuotation == id) || null
  );

export const selectPurchaseOrderDetails = (id: string) =>
  createSelector(
    selectOrderState,
    state => state.purchaseOrders.find(po => po.idPurchaseOrder == id) || null
  );
export const selectConfirmedOrderDetails = (id: string) =>
  createSelector(
    selectOrderState,
    state => state.confirmedOrders.find(co => co.idOrder == id) || null
  );

export const selectConfirmedOrderItems = (orderId: string, quoteId: string) =>
  createSelector(
    selectOrderState,
    state =>
      state.confirmedOrderItems.find(
        coi => coi.confirmedOrderId == orderId && coi.quoteId == quoteId
      )?.items || null
  );

export const selectPurchaseOrderItems = (
  purchaseOrderId: string,
  quoteId: string
) =>
  createSelector(
    selectOrderState,
    state =>
      state.purchaseOrderItems.find(
        poi => poi.purchaseOrderId == purchaseOrderId && poi.quoteId == quoteId
      )?.items || null
  );

export const selectUploadedOrderFile = createSelector(
  selectOrderState,
  state => state.uploadedOrderFile
);

export const selectOrderList = createSelector(
  selectOrderState,
  state => state.orderList
);

export const selectTotalLoadOrders = createSelector(
  selectOrderState,
  state => state.totalLoadOrders
);

export const selectIsLoadingOrders = createSelector(
  selectOrderState,
  state => state.isLoadingOrders
);
/**
 * Selector that retrieves the list of selected order items from the order state.
 *
 * @description
 * This selector extracts the `orderItemsListSelected` property from the OrderState,
 * returning an array of OrderItem objects that are currently selected.
 *
 * @param {OrderState} state - The order state slice from the store
 * @returns {OrderItem[]} An array of selected order items
 *
 * @example
 * // Use in a component
 * selectedItems$ = this.store.select(selectedItems);
 *
 * // Use with async pipe in template
 * <div *ngFor="let item of selectedItems$ | async">
 *   {{ item.name }}
 * </div>
 *
 * @see {@link OrderState} for the state structure
 * @see {@link OrderItem} for the item model
 */
export const selectedItems = createSelector(
  selectOrderState,
  (state: OrderState): OrderItem[] => state.orderItemsListSelected
);
//TODO: eliminar/reemplazar cuando se conecte el servicio
export const selectedItem = createSelector(
  selectOrderState,
  (state: OrderState): OrderItem | null =>
    state.orderItemsListSelected ? state.orderItemsListSelected[0] : null
);
